var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "registryservices" },
    [
      _c("PageHeader", {
        attrs: {
          title: "Manage Service Credentials",
          subtitle:
            "Credentials are used to authenticate your Camunda process instances. Use a separate credential for\n    each process instance. Credentials can only be viewed the first time they are generated.",
          icon: "assignment",
        },
      }),
      _vm._v(" "),
      _c(
        "Subheader",
        { attrs: { title: "Service Credentials", "no-search": "" } },
        [
          _c(
            "v-btn",
            {
              attrs: { loading: _vm.isGeneratingCredential, color: "success" },
              on: { click: _vm.generateNewCredentials },
            },
            [
              _c("v-icon", { attrs: { left: "" } }, [_vm._v("add")]),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("Button.GenerateNewCredentials")) +
                  "\n    "
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { staticClass: "showauthentications", attrs: { "mb-4": "" } },
        [
          _vm.isLoading
            ? _c("PageLoader", {
                attrs: { resourceName: "Service Credentials" },
              })
            : _c("ServiceCredentials", {
                attrs: { serviceCredentials: _vm.serviceCredentials },
              }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { padding: "20px" } },
        [
          _c("div", { staticClass: "headline mb-4" }, [_vm._v(" Client Id ")]),
          _vm._v(" "),
          _c("p", [
            _vm._v("\n      The Client Id is the same for all credentials. "),
            _c("br"),
            _vm._v(" "),
            !_vm.clientId
              ? _c("span", [
                  _vm._v(
                    "\n        To view the Client Id, have at least one credential generated.\n      "
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { "mt-5": "" } },
            [
              _c(
                "v-flex",
                { attrs: { sm6: "", md4: "", lg3: "" } },
                [
                  _vm.clientId
                    ? _c("ItemTextField", {
                        attrs: { title: "ClientId", value: _vm.clientId },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "headline mb-4" }, [
            _vm._v(" Reset Client Id "),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n      Only reset the Client Id if your credentials have been compromised. "
            ),
            _c("br"),
            _vm._v(
              "\n      All Camunda processes that use this Client Id must be updated.\n    "
            ),
          ]),
          _vm._v(" "),
          _c("ConfirmationDialog", {
            attrs: {
              loading: _vm.isResettingCredentials,
              title: "Reset Client Id",
              label: "Reset Client Id",
              text: "Are you sure you want to reset the client id? All Camunda process that use this client id must be updated.",
            },
            on: { submit: _vm.resetClientId },
          }),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("v-icon", { attrs: { color: _vm.resetColor } }, [
                _vm._v(_vm._s(_vm.resetIcon)),
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    display: "inline-block",
                    margin: "0 auto",
                    "margin-top": "10px",
                  },
                },
                [_vm._v(_vm._s(_vm.resetMessage))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }